import { DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row } from 'antd';
import React from 'react';

export const ContentSectionValuesRow = ({ inputValue, onInputChange, onDelete }) => {
  return (
    <Row style={{ alignItems: 'center' }} gutter={16}>
      <Col span={21}>
        <Input
          style={{ margin: '5px 0' }}
          value={inputValue}
          onChange={onInputChange}
          placeholder="Значение"
        />
      </Col>
      <Col span={1}>
        <Button onClick={onDelete}>
          <DeleteOutlined />
        </Button>
      </Col>
    </Row>
  );
};
